import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { DfpComponent } from "./dfp-component";

import "./ads.m.css";

const AdSlot = ({ id, ad_type, adStyleName = "" }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const networkId = get(qtState, ["config", "ads-config", "network_id"], "");
  const adConfig = get(qtState, ["config", "ads-config", "slots", ad_type], {});

  return (
    <DfpComponent
      adStyleName={adStyleName}
      id={id}
      path={`${networkId}/${adConfig.ad_unit}`}
      size={adConfig.sizes}
      viewPortSizeMapping={adConfig.view_port_size_mapping}
      type="top-ad"
    />
  );
};

const AdContainer = ({ id, desktop, mobile, AdClassName = "", showText = true }) => {
  return (
    <div styleName="Adcontainer">
      {showText ? (
        <span styleName="container-text" className="container-text">
          ADVERTISEMENT
        </span>
      ) : null}

      <div className="ad-background" styleName={`ad-background ${AdClassName}`}>
        {global.width >= 768 && desktop ? (
          <div styleName="desktop">
            <AdSlot id={`${id}`} ad_type={desktop} />
          </div>
        ) : null}

        {global.width <= 768 && mobile ? (
          <div styleName="mobile">
            <AdSlot id={`${id}`} ad_type={mobile} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const HeaderDesktopAd = () => {
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], "home-page"));

  const adsId = {
    "home-page": "div-gpt-ad-1680156194475-0",
    "story-page": "div-gpt-ad-1680156622758-0"
  };
  const ads = {
    "home-page": "DH_Desktop_HP_Billboard_Top",
    "story-page": "DH_Desktop_AT_Billboard"
  };
  return (
    <div styleName="header-container">
      <AdContainer
        AdClassName="standard-970x90"
        id={adsId[pageType] || "div-gpt-ad-1680156194475-0"}
        desktop={ads[pageType] || "DH_Desktop_HP_Billboard_Top"}
      />
    </div>
  );
};

const OutOfPageAd = () => {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  return (
    <>
      {!isMobile ? (
        <AdContainer
          className="hide-mobile"
          showText={false}
          id="div-gpt-ad-1680157592679-0"
          desktop="DH_Desktop_Interstitial"
        />
      ) : (
        <AdContainer
          className="hide-desktop"
          showText={false}
          id="div-gpt-ad-1680157627881-0"
          mobile="DH_Mobile_Interstitial"
        />
      )}
    </>
  );
};

export { AdSlot, AdContainer, HeaderDesktopAd, OutOfPageAd };
